import REText from '@components/wrappedBDS/REText';
import { Button, IconPopOut, Notification } from '@ftdr/blueprint-components-react';
import { isProdEnv } from '@helpers/utils';
import React, { useEffect, useState } from 'react';

export interface HBW210BannerProps {
  headerText?: string;
  infoText?: string;
  ctaText?: string;
  ctaProdUrl?: string;
  ctaUrl?: string;
  className?: string;
  dismissalKey?: string;
  buttonId?: string;
}

const HBW210Banner: React.FC<HBW210BannerProps> = (props) => {
  const [isNotificationDismissed, setIsNotificationDismissed] = useState(false);
  const isProd = isProdEnv();

  const dismissNotification = () => {
    try {
      if (props.dismissalKey) {
        localStorage.setItem(props.dismissalKey, 'true');
        setIsNotificationDismissed(true);
      }
    } catch (error) {
      console.warn('Failed to save dismissal state:', error);
      setIsNotificationDismissed(true);
    }
  };

  useEffect(() => {
    try {
      const isDismissalStored = props.dismissalKey
        ? localStorage.getItem(props.dismissalKey) === 'true'
        : false;
      setIsNotificationDismissed(isDismissalStored);
    } catch (error) {
      console.warn('Failed to read dismissal state:', error);
      setIsNotificationDismissed(false);
    }
  }, [props.dismissalKey]);

  return (
    <>
      {isNotificationDismissed ? null : (
        <div className="lg:px-6 md:px-6 flex min-w-48 max-w-xxl mx-auto mb-3">
          <Notification
            variant="floating"
            status="info"
            inline={true}
            showStatusLabel={false}
            className="flex items-center justify-between gap-1 py-4 px-6"
            onClose={dismissNotification}
          >
            <div className="flex flex-col gap-4 overflow-auto">
              {/* HEADER */}
              {props.headerText && (
                <REText variant="heading-04" className="zesty-html break-words">
                  {props.headerText}
                </REText>
              )}

              {/* INFO */}
              {props.infoText && (
                <REText variant="body-long" className="zesty-html break-words">
                  {props.infoText}
                </REText>
              )}

              {/* CTA TEXT AND URL */}
              {props.ctaText && (
                <div className="flex items-start">
                  <Button
                    id={`hbw210-btn-${props.buttonId}`}
                    label={props.ctaText}
                    labelAlign={'left'}
                    variant="outlined"
                    size="medium"
                    shape="pill"
                    startIcon={<IconPopOut />}
                    onClick={() =>
                      isProd
                        ? window.open(props.ctaProdUrl, '_blank', 'noopener,noreferrer')
                        : window.open(props.ctaUrl, '_blank', 'noopener,noreferrer')
                    }
                  />
                </div>
              )}
            </div>
          </Notification>
        </div>
      )}
    </>
  );
};

export default HBW210Banner;
